import { Amplify } from 'aws-amplify';

/**
 * AWS Amplify Configuration
 * Uses the existing AWS configuration from utils/aws.js
 * Configured for phone number authentication with OTP verification
 */
const amplifyConfig = {
  Auth: {
    mandatorySignIn: true,
    Cognito: {
      region: 'ap-south-1',
      userPoolId: 'ap-south-1_UL05sWBeG',
      userPoolClientId: '7crb1v5671jub4phv1phli5mtm',
      identityPoolId: 'ap-south-1:1608bbc3-e022-407f-9a05-07777b82e65c',
      signUpVerificationMethod: 'code', // Use 'code' for OTP verification
      loginWith: {
        phone: true, // Enable phone number authentication
      },
      authenticationFlowType: 'CUSTOM_WITHOUT_SRP',
    },
  },
  PubSub: {
    AWSIoT: {
      region: 'ap-south-1',
      endpoint: 'wss://a3t7o9jx4m20m3-ats.iot.ap-south-1.amazonaws.com/mqtt',
    }
  }
};

// Initialize Amplify
Amplify.configure(amplifyConfig);

export default amplifyConfig;
